var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 11.25,
    fill: "#252D44"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.697 17.187V25.6382H23.3309V17.5544C23.3309 16.9492 22.9851 16.5818 21.9043 16.5818C21.1911 16.5818 20.6075 16.9708 20.0239 17.468V25.6382H15.6145V17.5544C15.6145 16.9492 15.2903 16.5818 14.2096 16.5818C13.5396 16.5818 12.9343 16.9276 12.3075 17.4464V25.6382H7.94141V14.5716H12.3075V16.6034C13.2369 15.3713 14.5554 14.3555 16.6088 14.3555C18.446 14.3555 19.6781 15.1336 19.959 16.8627C20.8236 15.5659 22.2502 14.3555 24.2819 14.3555C26.465 14.3555 27.697 15.3281 27.697 17.187Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8861 20.9987L29.5664 23.3184L31.8861 25.638L34.2058 23.3184L31.8861 20.9987Z",
    fill: "#FF576D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppLogo);
export default __webpack_public_path__ + "static/media/app-logo.ce4f5aa0badd0f17ce135bb6056d5dea.svg";
export { ForwardRef as ReactComponent };